import { z } from 'zod';

const schema = z.object({
  VITE_SUPABASE_URL: z.url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_API_BASE: z.string().default(''),
  VITE_SENTRY_DSN: z.string().default(''),
  VITE_APP_VERSION: z.string().default('local'),
  VITE_NOCONFLICT_ENV: z.string().default('local'),
  // Empty where payments are not configured (PR environments, a fresh checkout): the pay page says so.
  VITE_STRIPE_PUBLISHABLE_KEY: z
    .union([z.literal(''), z.string().regex(/^pk_(test|live)_/)])
    .default(''),
  // The privacy policy the script upload notice links to.
  VITE_PRIVACY_POLICY_URL: z.url().default('https://www.noconflictclearance.com/privacy'),
});

/** Validates Vite env at startup. */
export function parseWebEnv(raw: Record<string, unknown>) {
  const v = schema.parse(raw);
  return {
    supabaseUrl: v.VITE_SUPABASE_URL,
    supabaseAnonKey: v.VITE_SUPABASE_ANON_KEY,
    apiBase: v.VITE_API_BASE,
    sentryDsn: v.VITE_SENTRY_DSN,
    appVersion: v.VITE_APP_VERSION,
    appEnv: v.VITE_NOCONFLICT_ENV,
    stripePublishableKey: v.VITE_STRIPE_PUBLISHABLE_KEY,
    privacyPolicyUrl: v.VITE_PRIVACY_POLICY_URL,
  };
}

export const env = parseWebEnv(import.meta.env);
